
import Navigation from './Navigation.vue'
import Search from './Search.vue'
import LangSelect from './LangSelect.vue'
import Account from './Account.vue'
import MobileNavigation from './MobileNavigation.vue'
import Logo from './Logo.vue'

export default {
  components: {
    Navigation,
    Logo,
    Search,
    LangSelect,
    Account,
    MobileNavigation,
  },
  props: {
    portalModalOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navIsOpened: false,
      navScrollTrigger: null,
      slideAnimation: null,
      pauseAnimation: false,
    }
  },
  watch: {
    '$store.state.settings': {
      handler(settings) {
        if (!settings.showBanner) {
          // refresh trigger (re-positions nav to top) when closing banner
          this.$ScrollTrigger.refresh()
        }
      },
    },
    // '$store.state.app.breakpoint': {
    //   handler() {
    //     if (this.$matchMedia('lg')) {
    //       // desktop
    //       // re-enable scrolltrigger when resizing back to desktop
    //       this.navScrollTrigger?.enable(true)
    //     } else {
    //       // mobile
    //       // disable scrolltrigger on mobile
    //       this.navScrollTrigger?.disable()
    //       // make sure nav is visible when resizing to mobile
    //       this.slideAnimation?.reverse()
    //     }
    //   },
    // },
  },
  mounted() {
    this.$nextTick(() => {
      // media query context
      const mm = this.$gsap.matchMedia(this.$refs.navHeader) // scope to navHeader only

      // executes desktop only - lg breakpoint
      mm.add('(min-width: 1024px)', () => {
        this.initAnim()
      })
    })
  },
  methods: {
    initAnim() {
      // lock scroll to give gsap time to setup
      document.body.style.overflow = 'hidden'
      // pause animation on load
      this.pauseAnimation = true

      // slide anim
      this.slideAnimation = this.$gsap.to(this.$refs.headerContainer, {
        opacity: 1,
        pointerEvents: 'auto',
        yPercent: -100,
        duration: 0.2,
        ease: 'easeOut',
        paused: true,
      })

      // trigger slide animation on scroll
      this.navScrollTrigger = this.$ScrollTrigger.create({
        trigger: this.$refs.navHeader,
        // markers: true,
        pin: this.$refs.headerPin,
        // anticipatePin: true,
        start: 'top top',
        end: 'max',
        onUpdate: (self) =>
          !this.navIsOpened && this.onUpdateHeaderScroll(self),
      })

      document.body.style.overflow = 'scroll'
      this.pauseAnimation = false

      this.$gsap.delayedCall(1, () => {
        // make sure scroll triggers are updated after render
        this.navScrollTrigger.refresh()
      })
    },

    onUpdateHeaderScroll(self) {
      if (this.$store.state.app.navOpened || this.pauseAnimation) {
        return
      }

      // up 0 percent
      if (self.direction === -1 || self.progress === 0) {
        this.slideUp()
      }

      // down -100 percent
      if (self.direction === 1 && self.progress > 0.01) {
        this.slideDown()
      }
    },
    slideUp() {
      this.slideAnimation?.reverse()
    },
    slideDown() {
      this.slideAnimation?.play()
    },
  },
}
